import { cn } from "@/lib/utils";

interface StatPillProps {
  value: string;
  label: string;
  className?: string;
}

export const StatPill = ({ value, label, className }: StatPillProps) => {
  return (
    <div className={cn("stat-pill", className)}>
      <span className="stat-pill-value">{value}</span> {label}
    </div>
  );
};

interface PillProps {
  children: React.ReactNode;
  accent?: string;
  className?: string;
}

export const Pill = ({ children, accent, className }: PillProps) => {
  return (
    <div className={cn("pill", className)}>
      {children}
      {accent && <span className="pill-accent">{accent}</span>}
    </div>
  );
};

interface LabelPillProps {
  label: string;
  value: string;
  className?: string;
}

export const LabelPill = ({ label, value, className }: LabelPillProps) => {
  return (
    <div className={cn("label-pill", className)}>
      {label} <span className="label-pill-value">{value}</span>
    </div>
  );
};
